import { useState } from 'react';

/**
 * Break-glass switch for the create-session modal.
 *
 * The redesigned modal (CreateSessionStudio) is the DEFAULT — there is
 * intentionally NO on-screen control. If it ever misbehaves during a live
 * session/demo, an admin can fall back to the classic SessionSettings modal
 * WITHOUT a deploy: load the trainer dashboard with `?classicCreate=1` in the
 * URL. Removing the param (or reloading the plain URL) goes back to the new
 * modal. The param is read once on mount, so change it then reload to apply.
 *
 * Returns true when the classic modal should be rendered.
 */
const URL_PARAM = 'classicCreate';

export function useClassicCreateModal(): boolean {
  const [classic] = useState<boolean>(() => {
    try {
      return new URLSearchParams(window.location.search).get(URL_PARAM) === '1';
    } catch {
      return false;
    }
  });

  return classic;
}
